import * as React from 'react';
import * as styles from './navigation.css';

export interface INavigationProps {
  leftImage?: string;
}

export class NavigationBar extends React.PureComponent<INavigationProps, {}> {
  render() {
    return (
      <div className={styles.navigationBar}>
        <a className={styles.navigationBarLeftImage} href="https://marquee.gs.com/">
          <img src={this.props.leftImage} />
        </a>
      </div>
    );
  }
}
